<div [class.hidden]="!show">
    <div *ngIf="show" ></div>
            <ng-http-loader [minDuration]="300"     [extraDuration]="3000" ></ng-http-loader>
</div>